export default __webpack_public_path__ + "static/media/delete.cdffc55a.svg";